const getters={
    UserToken: state => state.currentUser.UserToken,
    UserName: state => state.currentUser.UserName,
    UserId: state => state.currentUser.UserId,
    UserMail: state => state.currentUser.UserMail,
    UserPhone: state => state.currentUser.UserPhone,
    Keywords: state=>state.keywords,
    keywordtime: state=>state.keywordtime,
    getGoodsWhere:function(state){
        var conditions = {};
        conditions.attr = [];
        if(state.conditions!=undefined&&state.conditions.length>0){
            for(var i in state.conditions){
                if(state.conditions[i]!=undefined){
                    if(state.conditions[i].class=="class"){
                        conditions.classid = state.conditions[i].mid;
                    }else if(state.conditions[i].class=="sonclass"){
                        conditions.sonclassid = state.conditions[i].mid;
                    }else{                
                        conditions.attr.push(state.conditions[i].mid);
                    }
                }
                
            }
        }
       
        return conditions;
    },
    compareList: state => state.compareList,
    compareListVersion: state => state.compareListVersion
}
export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js